jQuery(document).ready(function(){
	jQuery('.home-banner').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
		dots: true,
		autoplay:true,
  		autoplaySpeed:5000,
		adaptiveHeight: true
	});
	jQuery('.bestseller-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.deal-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.customer-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		infinite: true,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	// jQuery('.result-silder').slick({
	// 	slidesToShow: 5,
	// 	slidesToScroll: 1,
	// 	centerPadding: '10px',
	// 	centerMode: true,
	// 	arrows: false,
	// 	infinite: true,
	// 	initialSlide:2,
	// 	responsive: [
	// 		{
	// 			breakpoint: 1399,
	// 			settings: {
	// 				arrows: false,
	// 				dots: false,
	// 				slidesToShow: 3,
	// 				slidesToScroll: 1
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 767,
	// 			settings: {
	// 				centerPadding: '0px',
	// 				centerMode: true,
	// 				arrows: false,
	// 				dots: false,
	// 				slidesToShow: 1,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });

jQuery('.result-silder').slick({
	slidesToShow: 5,
	slidesToScroll: 1,
	centerPadding: '10px',
	centerMode: true,
	arrows: true,
	infinite: true,
	initialSlide: 2,
	responsive: [
		{
			breakpoint: 1399,
			settings: {
				arrows: false,
				dots: false,
				slidesToShow: 3,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 767,
			settings: {
				centerPadding: '0px',
				centerMode: true,
				arrows: false,
				dots: false,
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
});

// Add click event to center clicked slide
jQuery('.result-silder').on('click', '.slick-slide', function (e) {
	var index = jQuery(this).data("slick-index");
	jQuery('.result-silder').slick('slickGoTo', index);
});

	jQuery('.blog-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
	});
	jQuery('.covered-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	
	$('.product-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		infinite: false,
		asNavFor: '.product-nav',
		responsive: [
			{
				breakpoint: 991,
				settings: {
					dots: false,
				}
			}
		]
	});
	$('.product-nav').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '.product-slider',
		dots: false,
		arrows: false,
		infinite: false,
		vertical:true,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					arrows: false,
					vertical:false,
					dots: false,
					slidesToShow: 4,
					slidesToScroll: 1
				}
			}
		]
	});

	jQuery('.executive-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					arrows: true,
					dots: false,
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 991,
				settings: {
					arrows: true,
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	$('.culture-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		infinite: false,
	});
	$('.story-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		infinite: false,
		asNavFor: '.story-nav',
	});
	$('.story-nav').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '.story-slider',
		dots: false,
		arrows: true,
		infinite: false,
		vertical:false,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					arrows: true,
					vertical:false,
					dots: false,
					slidesToShow: 3,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.hear-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					arrows: true,
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 991,
				settings: {
					arrows: true,
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.sleep-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 479,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	

    //  $('.mini-also-slider').slick({
	//  	slidesToShow: 1,
	//  	slidesToScroll: 1,
	//  	dots: false,
	//  	arrows: true,
	//  	infinite: false,
	//  });
    $(document).on('click', '.discount-sec .discount-top', function() {
		$('.coupon-form').toggleClass('active');
		$('.discount-top').toggleClass('active');
	});
	

	const header = $('.header');
	// const sleepheader = $('.rental-pageslide');
  	let lastScroll = 0;
	$(window).scroll(function() {
		const currentScroll = $(this).scrollTop();
		
		if (currentScroll > lastScroll && currentScroll > 50) {
		// Scroll down
		header.addClass('sticky');
		// sleepheader.addClass('sleepsticky'); 
		$('main').css('padding-top', header.outerHeight() + 'px');
		} else if (currentScroll + $(window).height() < $(document).height() && currentScroll <= 50) {
		// Near top of page
		header.removeClass('sticky');
		// sleepheader.addClass('sleepsticky'); 
		$('main').css('padding-top', '0');
		}
		
		lastScroll = currentScroll;
	});

	const menu = $('.rental-pageslide');
	const links = $('.rental-pageslide a');
	let headerOffset = 80; // adjust according to header height

	// Ensure first link is active on load
	links.removeClass('active');
	links.first().addClass('active');

	// 🔹 CLICK TO SCROLL
	links.on('click', function (e) {
		e.preventDefault();

		const target = $(this).attr('href');
		const scrollPosition = $(target).offset().top - headerOffset;

		$('html, body').animate({ scrollTop: scrollPosition }, 1200);

		links.removeClass('active');
		$(this).addClass('active');
	});

	// 🔹 SCROLL EVENTS
	$(window).on('scroll', function () {
		const scrollPos = $(this).scrollTop();

		// Sticky menu toggle
		menu.toggleClass('sleepsticky', scrollPos > 100);

		// Highlight based on section position
		$('section[id], div[id], picture[id]').each(function () {
			const top = $(this).offset().top - headerOffset - 10;
			const bottom = top + $(this).outerHeight();

			if (scrollPos >= top && scrollPos <= bottom) {
				const id = $(this).attr('id');
				links.removeClass('active');
				$(`.rental-pageslide a[href="#${id}"]`).addClass('active');
			}
		});
	});

	// $('.rental-pageslide a').on('click', function(e) {
	// 	e.preventDefault();

	// 	const target = $(this).attr('href');
	// 	const wrapper = $('html,body'); // scroll container

	// 	// Calculate the exact scroll position
	// 	const scrollPosition = $(target).position().top + wrapper.scrollTop();

	// 	wrapper.animate({
	// 		scrollTop: scrollPosition
	// 	}, 400);

	// 	// Active class handling
	// 	$('.rental-pageslide a').removeClass('active');
	// 	$(this).addClass('active');
	// });

	// Highlight menu link on scroll
	function updateActiveLink() {
		const scrollPos = $(window).scrollTop() + headerOffset + 10; // +10 buffer

		$menuLinks.each(function () {
		const currentLink = $(this);
		const target = $(currentLink.attr('href'));
		if (!target.length) return;

		const sectionTop = target.offset().top;
		const sectionBottom = sectionTop + target.outerHeight();

		if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
			$menuLinks.removeClass('active');
			currentLink.addClass('active');
		}
		});
	}

	// Run on scroll and on load
	$(window).on('scroll', updateActiveLink);
	$(window).on('load', updateActiveLink);


	if(window.matchMedia("(min-width: 992px)").matches){
		jQuery('.take-slider').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			infinite: false,
		});
	}
	if(window.matchMedia("(min-width: 768px)").matches){
		$('.take-slider').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			infinite: false,
		});
		
	}
	
	if(window.matchMedia("(max-width: 991px)").matches){
		
		jQuery('.works-grid').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			infinite: false,
			responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
		});
	}
	
  
	if(window.matchMedia("(max-width: 991px)").matches){
		
		// document.querySelector('.nav-bar').addEventListener('click', function (e) {
		// 	document.querySelector('.header-menu').classList.toggle('active');
		// 	document.querySelector('.header-mobile-btn').classList.toggle('active');
		// 	$('.header-search').removeClass('active');
		// });
		document.querySelector('.nav-bar').addEventListener('click', function (e) {
		e.stopPropagation(); // Prevent bubbling to document click
		document.querySelector('.header-menu').classList.toggle('active');
		document.querySelector('.header-mobile-btn').classList.toggle('active');
		document.querySelector('body').classList.toggle('bodyoverlay');
		$('.header-search').removeClass('active');
		});

		document.addEventListener('click', function (e) {
		const navBar = document.querySelector('.nav-bar');
		const headerMenu = document.querySelector('.header-menu');
		const headerBtn = document.querySelector('.header-mobile-btn');

		if (!navBar.contains(e.target)) {
			headerMenu.classList.remove('active');
			headerBtn.classList.remove('active');
		}
		});

		const navArrows = document.querySelectorAll('.nav-arrow');
			navArrows.forEach(arrow => {
			arrow.addEventListener('click', function (e) {
				e.stopPropagation();
				const navItem = this.closest('.nav-item');
				document.querySelectorAll('.nav-item.active').forEach(item => {
				if (item !== navItem) {
					item.classList.remove('active');
				}
				});
				navItem.classList.toggle('active');
			});
		});
		
		const resmedHeadings = document.querySelectorAll('.resmedxsheading');
		resmedHeadings.forEach(heading => {
			heading.addEventListener('click', function (e) {
				e.stopPropagation();
				const menuCol = this.closest('.menu-col');
				document.querySelectorAll('.menu-col.active').forEach(menuColItem => {
					if (menuColItem !== menuCol) {
						menuColItem.classList.remove('active');
					}
				});
				menuCol.classList.toggle('active');
			});
		});

		// Close menus when clicking outside
		document.addEventListener('click', function (e) {
			// Close mega menus
			document.querySelectorAll('.nav-item.active').forEach(item => {
				if (!item.contains(e.target)) {
					item.classList.remove('active');
				}
			});

			// Close menu columns
			document.querySelectorAll('.menu-col.active').forEach(col => {
				if (!col.contains(e.target)) {
					col.classList.remove('active');
				}
			});
		});
	}

	if(window.matchMedia("(max-width: 767px)").matches){
		
		jQuery('.benefits-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
		});
		jQuery('.recent-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
		});
		$('.search-btn').on('click', function() {
			$('.header-search').toggleClass('active');
			$('.header-mobile-btn').removeClass('active');
			$('.header-menu').removeClass('active');
		});
		$('.mobile-search-btn').on('click', function() {
			$('.form-search').toggleClass('active');
		});
		
		jQuery(".account-left-top").click(function(){
			jQuery(".account-left").toggleClass("accountactive");
	  	});
		
		const footerTab = document.querySelectorAll('.footer-col');

		footerTab.forEach(footercard => {
			const footerHeader = footercard.querySelector('.footer-col .resmedxsheading');

			footerHeader.addEventListener('click', function () {
				// Close all footerTab first
				footerTab.forEach(c => {
					if (c !== footercard) {
						c.classList.remove('active');
					}
				});

				// Toggle current card
				footercard.classList.toggle('active');
			});
		});
		
	}
});



document.addEventListener('DOMContentLoaded', function () {
	
	const realCards = document.querySelectorAll('.result-card');
	const realLists = document.querySelectorAll('.result-list');
	realCards.forEach(realCard => {
		realCard.addEventListener('click', function () {
			const targetId = this.getAttribute('data-target');
			realCards.forEach(c => c.classList.remove('active'));
			this.classList.add('active');
			realLists.forEach(list => list.classList.remove('active'));
			document.getElementById(targetId).classList.add('active');
		});
	});
	const tabs = document.querySelectorAll('.sleep-tab-list li');
	const tabContents = document.querySelectorAll('.sleep-tab-card');

	tabs.forEach(tab => {
		tab.addEventListener('click', function () {
			// Remove active class from all tabs and contents
			tabs.forEach(t => t.classList.remove('active'));
			tabContents.forEach(c => c.classList.remove('active'));

			// Add active class to clicked tab
			this.classList.add('active');

			// Show corresponding content
			const tabId = this.getAttribute('data-tab');
			document.getElementById(tabId).classList.add('active');
		});
	});
	const contactTabs = document.querySelectorAll('.contact-tab-list li');
	const contacttabContents = document.querySelectorAll('.contact-tab-card');

	contactTabs.forEach(contacttab => {
		contacttab.addEventListener('click', function () {
			// Remove active class from all contactTabs and contents
			contactTabs.forEach(t => t.classList.remove('active'));
			contacttabContents.forEach(c => c.classList.remove('active'));

			// Add active class to clicked tab
			this.classList.add('active');

			// Show corresponding content
			const contacttabId = this.getAttribute('data-tab');
			document.getElementById(contacttabId).classList.add('active');
			this.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest'
            });
		});
	});

	const cards = document.querySelectorAll('.sleep-card');

	cards.forEach(card => {
		const cardHeader = card.querySelector('.sleep-card-first');

		cardHeader.addEventListener('click', function () {
			// Close all cards first
			cards.forEach(c => {
				if (c !== card) {
					c.classList.remove('active');
				}
			});

			// Toggle current card
			card.classList.toggle('active');
		});
	});

	const whatWeCards = document.querySelectorAll('.whatwe-tab');

	whatWeCards.forEach(whatWecard => {
		const whatWecardHeader = whatWecard.querySelector('.whatwe-top');

		whatWecardHeader.addEventListener('click', function () {
			// Close all whatWeCards first
			whatWeCards.forEach(c => {
				if (c !== whatWecard) {
					c.classList.remove('active');
				}
			});

			// Toggle current card
			whatWecard.classList.toggle('active');
		});
	});

	const benefitCards = document.querySelectorAll('.benefit-card');

	benefitCards.forEach(benefitcard => {
		const benefitcardHeader = benefitcard.querySelector('.benefit-card-first');

		benefitcardHeader.addEventListener('click', function () {
			// Close all cards first
			benefitCards.forEach(c => {
				if (c !== benefitcard) {
					c.classList.remove('active');
				}
			});

			// Toggle current card
			benefitcard.classList.toggle('active');
		});
	});

	const faqItems = document.querySelectorAll('.faq-item');
	if (faqItems.length > 0) {
		faqItems[0].classList.add('active');
	}
	const faqTops = document.querySelectorAll('.faq-top');
	faqTops.forEach(top => {
		top.addEventListener('click', function () {
			const faqItem = this.closest('.faq-item');
			const isActive = faqItem.classList.contains('active');
			faqItems.forEach(item => {
				item.classList.remove('active');
			});
			if (!isActive) {
				faqItem.classList.add('active');
			}
		});
	});

	const productFaqItems = document.querySelectorAll('.product-faq');
	// if (productFaqItems.length > 0) {
	// 	productFaqItems[0].classList.add('active');
	// }
	const productFaqTops = document.querySelectorAll('.product-faq-top');
	productFaqTops.forEach(top => {
		top.addEventListener('click', function () {
			const productFaqItem = this.closest('.product-faq');
			const isActive = productFaqItem.classList.contains('active');
			productFaqItems.forEach(productFaqItem => {
				productFaqItem.classList.remove('active');
			});
			if (!isActive) {
				productFaqItem.classList.add('active');
			}
		});
	});
	document.addEventListener('click', function (e) {
		const plusBtn = e.target.closest('.quantity-btn.plus');
		const minusBtn = e.target.closest('.quantity-btn.minus');

		if (plusBtn || minusBtn) {
			const container = (plusBtn || minusBtn).closest('.quantity');
			const input = container.querySelector('.quantity-input');

			// Get normalized value (0 for invalid/negative numbers)
			let value = parseInt(input.value);
			if (isNaN(value)) value = 0;  // Fixed: Added missing parenthesis
			if (value < 0) value = 0;

			// Update value based on button clicked
			if (plusBtn) {
				value++;
			} else if (minusBtn) {
				value = Math.max(0, value - 1); // Prevent negative values
			}

			input.value = value; // Update input field
		}
	});
	const environmentalTabs = document.querySelectorAll('.environmental-tab-list li');
	const environmentaltabContents = document.querySelectorAll('.environmental-tab-card');

	environmentalTabs.forEach(environmentaltab => {
		environmentaltab.addEventListener('click', function () {
			// Remove active class from all environmentalTabs and contents
			environmentalTabs.forEach(t => t.classList.remove('active'));
			environmentaltabContents.forEach(c => c.classList.remove('active'));

			// Add active class to clicked tab
			this.classList.add('active');

			// Show corresponding content
			const environmentaltabId = this.getAttribute('data-tab');
			document.getElementById(environmentaltabId).classList.add('active');
			this.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest'
            });
		});
	});
}); 


document.addEventListener('DOMContentLoaded', function () {
  const shareBtn = document.querySelector('.product-top-btn .share-btn');
const shareList = document.querySelector('.share-list');

if (shareBtn && shareList) {
  shareBtn.addEventListener('click', function (e) {
    e.stopPropagation(); // Prevent the click from bubbling to the document
    shareList.classList.toggle('active');
  });

  shareList.addEventListener('click', function (e) {
    e.stopPropagation(); // Allow interaction with shareList without closing it
  });

  document.addEventListener('click', function () {
    shareList.classList.remove('active');
  });
}

if (!$("#compare-products").hasClass("hidden")) {
  $("body").addClass("bodyoverlay");
} else {
  $("body").removeClass("bodyoverlay");
}
});





// krishna js for sleep test page

// =================== how it works section =====================
document.addEventListener("DOMContentLoaded", () => {

  const rentalSlider = $(".cust-rental .works-grid");

  if (!rentalSlider.length || !$.fn.slick) return;

  rentalSlider.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    adaptiveHeight: false,

    autoplay: true,
    autoplaySpeed: 5000,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
	  {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

});

document.addEventListener("DOMContentLoaded", () => {

  const rentalSlider3 = $(".cust-rental-3 .works-grid");

  if (!rentalSlider3.length || !$.fn.slick) return;

  rentalSlider3.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    adaptiveHeight: false,

    autoplay: true,
    autoplaySpeed: 5000,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
	  {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

});
